import { constants } from '@yola/subscription-manager-js';
import {
  CUSTOM_DOMAIN,
  PREMIUM_COMPOSITE_GROUP,
  PUBLISHING,
  AI_LOCALIZATION,
} from '../constants/upsell-types';

const { hostingPackageFeatureNames } = constants;

const getHighlightedHostingPackageFeatures = (upsellType, hasDomainExtraPrice, details) =>
  ({
    [CUSTOM_DOMAIN]: [
      { name: hostingPackageFeatureNames.CUSTOM_DOMAIN, position: 2 },
      hasDomainExtraPrice && { name: hostingPackageFeatureNames.FREE_DOMAIN_PROMO, position: 3 },
    ].filter(Boolean),
    [PUBLISHING]: [
      { name: hostingPackageFeatureNames.CUSTOM_DOMAIN, position: 2 },
      hasDomainExtraPrice &&
        !details?.reactivateSubscription && {
          name: hostingPackageFeatureNames.FREE_DOMAIN_PROMO,
          position: 3,
        },
    ].filter(Boolean),
    [PREMIUM_COMPOSITE_GROUP]: [
      {
        name: hostingPackageFeatureNames.PREMIUM_COMPOSITE_GROUP,
        position: 2,
      },
    ],
    [AI_LOCALIZATION]: [
      {
        name: hostingPackageFeatureNames.AI,
      },
      details?.isAiLocalizationEnabled && {
        name: hostingPackageFeatureNames.AI_LOCALIZATION,
        position: 2,
      },
    ],
  })[upsellType] || null;

export default getHighlightedHostingPackageFeatures;
